<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>材料管理</el-breadcrumb-item>
      <el-breadcrumb-item>材料列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <div class="filter">
        <el-form
          :inline="true"
          :model="filter"
          ref="filterForm"
          label-position="right"
          label-width="80px"
          class="search-form"
          size="small"
        >
          <el-form-item label="关键词">
            <el-input
              size="small"
              v-model="filter.query"
              autocomplete="off"
              placeholder="名称、编码"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="filter.status">
              <el-option key="1" label="启用" :value="1"></el-option>
              <el-option key="2" label="禁用" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div style="margin-left: 80px">
          <el-button
            type="primary"
            size="small"
            @click="
              filter.page = 1
              getProductData()
            "
            >筛选</el-button
          >
          <el-button size="small" @click="getProductData(true)">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel">
      <CommodityCategoryFilter
        v-model="filter.category"
        @change="commodityCategoryChange"
      ></CommodityCategoryFilter>
      <ItemTable
        :list="list"
        :commodityCategory="commodityCategory"
        v-if="filter.category"
      ></ItemTable>
      <el-pagination
        background
        class="m-t-20 text-right"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        @current-change="getProductData()"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import ItemTable from './table'
import { commodityList } from '@/service/getData'
import CommodityCategoryFilter from '@/components/select/commodity_category_filter.vue'

export default {
  components: {
    ItemTable,
    CommodityCategoryFilter,
  },
  data() {
    return {
      commodityCategory: {},
      list: [],
      total: 0,
      filter: {
        admin: true,
        category: 0,
        page: 1,
        size: 10,
        query: '',
        status: '',
      },
    }
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = JSON.parse(this.$route.query.filter)
    }
  },
  methods: {
    commodityCategoryChange(e) {
      this.commodityCategory = e
      this.filter.category = e.id
      this.filter.page = 1
      this.getProductData()
    },

    async getProductData(reset = false) {
      if (reset) {
        this.filter.page = 1
        this.filter.query = ''
        this.filter.status = ''
      }

      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      let data = this.clone(this.filter)
      data.page -= 1

      let res = await commodityList(data)
      if (res.status == 0) {
        this.list = res.data.list
        this.total = res.data.count
      }
    },
  },
}
</script>